class SproutTopupButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');

    if (!this.button) {
      return;
    }

    this.onClick = this.onClick.bind(this);
    this.button.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.button?.removeEventListener('click', this.onClick);
  }

  async onClick() {
    if (this.button.getAttribute('aria-busy') === 'true') {
      return;
    }

    const variantId = this.dataset.variantId;
    this.button.setAttribute('aria-busy', 'true');

    try {
      // Mirrors the theme's own product-form add-to-cart flow: bundle the cart-drawer section so the
      // server-rendered markup (bottle count, price, line item) comes back fresh in one round trip.
      const sectionsToBundle = [];

      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }));

      const formData = new FormData();
      formData.set('id', variantId);
      formData.set('quantity', '1');
      formData.set('sections', sectionsToBundle.join(','));
      formData.set('sections_url', `${Shopify.routes.root}variants/${variantId}`);

      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || 'Failed to add to cart');
      }

      // The full cart page (unlike the drawer) doesn't live-patch its own table via cart:change — the
      // theme's own quantity controls just reload the page there too, so match that pattern.
      if (window.themeVariables?.settings?.pageType === 'cart') {
        window.location.reload();
        return;
      }

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent.sections = responseJson.sections;

      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'variant:add',
          cart: cartContent,
        },
      }));
    } catch (error) {
      console.error(error);
    } finally {
      this.button.removeAttribute('aria-busy');
    }
  }
}

if (!window.customElements.get('sprout-topup-button')) {
  window.customElements.define('sprout-topup-button', SproutTopupButton);
}
